import { DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useApp } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Modal } from '../../../shared';
import WarrantyForm from './WarrantyForm';

function WarrantyFormModal({
  isOpen,
  onClose,
  productionOrderId,
  refetch = null,
}) {
  const { isCustomer } = useApp();
  const [showVideoOverlay, setShowVideoOverlay] = useState(true);

  const handleDismissVideo = () => {
    setShowVideoOverlay(false);
  };

  const handleModalClose = () => {
    setShowVideoOverlay(true);
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      setOpen={handleModalClose}
      size="4xl"
      showCloseButton
      panelClass="relative bg-white rounded-lg transition-all sm:my-8 sm:w-full"
    >
      {isCustomer && showVideoOverlay && (
        <div className="absolute inset-0 z-50 flex flex-col items-center justify-center rounded-lg bg-white">
          <button
            type="button"
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-rcprimary-400 focus:ring-offset-2"
            onClick={handleDismissVideo}
          >
            <span className="sr-only">Close</span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="w-full px-8 text-center">
            <h3 className="mb-4 font-semibold text-gray-900 text-lg">
              Are you just looking for general retainer fit and care
              information? We've created a short helpful video.
              <br />
              <span
                className="cursor-pointer text-rcprimary-400 text-xs"
                onClick={handleDismissVideo}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleDismissVideo();
                  }
                }}
              >
                Click here to close the video and continue with your claim.
              </span>
            </h3>
            <div className="relative mx-auto aspect-video w-full max-w-4xl">
              <iframe
                className="absolute inset-0 h-full w-full rounded-lg"
                src="https://www.youtube.com/embed/Fbz5o0PNNBI"
                title="Retainer fit and care information"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}

      <div className="pt-8">
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-bold text-2xl text-gray-900 capitalize leading-6"
          >
            Perfect Fit Guarantee Request
          </DialogTitle>
          <p className="mt-1 text-gray-600 text-sm">
            Submit a request for a free remake if your retainer doesn't fit
            properly.
            <br />
            <div className="mx-auto my-1 w-64 border-gray-300 border-b" />
            {isCustomer ? (
              <span className="font-bold">
                Have a lost shipment? Visit our{' '}
                <a
                  href="https://www.retainerclub.com/support"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-rcprimary-400"
                >
                  customer support page
                </a>{' '}
                to continue.
              </span>
            ) : (
              <span className="font-bold">
                Have a lost shipment? Contact the Partner Success Team
              </span>
            )}
            {isCustomer && (
              <>
                <br />
                You can also watch our helpful video by clicking{' '}
                <span
                  className="cursor-pointer text-rcprimary-400"
                  onClick={() => setShowVideoOverlay(true)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setShowVideoOverlay(true);
                    }
                  }}
                >
                  here
                </span>
                .
              </>
            )}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <WarrantyForm
          productionOrderId={productionOrderId}
          isModal={true}
          onClose={handleModalClose}
          refetch={refetch}
        />
      </div>
    </Modal>
  );
}

WarrantyFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  productionOrderId: PropTypes.string.isRequired,
  refetch: PropTypes.func,
};

export default WarrantyFormModal;
